import User from "./User" ;
import DateTime from "../core/DateTime" ;
import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;


  export default  class  SalesLeadCountRequest extends  DBObject {  private static readonly _FROMDATE: number = 0 ;
  private static readonly _PAGESIZE: number = 1 ;
  private static readonly _TODATE: number = 2 ;
  private static readonly _USER: number = 3 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _user: User = null ;
  private _pageSize: number = 0 ;
  private _toDate: DateTime = null ;
  private _fromDate: DateTime = null ;
 public constructor ( d3eParams ? : Partial<{fromDate: DateTime, pageSize: number, toDate: DateTime, user: User}> ) {
 super();

this.setFromDate(d3eParams?.fromDate ?? null);

this.setPageSize(d3eParams?.pageSize ?? 0);

this.setToDate(d3eParams?.toDate ?? null);

this.setUser(d3eParams?.user ?? null);
 }
  public get d3eType (  ) : string {
 return 'SalesLeadCountRequest' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get isTransientModel (  ) : boolean {
 return ; 
 }
  public get user (  ) : User {
 return this._user ; 
 }
  public setUser ( val : User ) : void {
 let isValChanged :boolean=this._user !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(SalesLeadCountRequest._USER,this._user);

this.updateObservable('user',this._user,val);

this._user=val;

this.fire('user',this);
 }
  public get pageSize (  ) : number {
 return this._pageSize ; 
 }
  public setPageSize ( val : number ) : void {
 let isValChanged :boolean=this._pageSize !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(SalesLeadCountRequest._PAGESIZE,this._pageSize);

this._pageSize=val;

this.fire('pageSize',this);
 }
  public get toDate (  ) : DateTime {
 return this._toDate ; 
 }
  public setToDate ( val : DateTime ) : void {
 let isValChanged :boolean=this._toDate !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(SalesLeadCountRequest._TODATE,this._toDate);

this._toDate=val;

this.fire('toDate',this);
 }
  public get fromDate (  ) : DateTime {
 return this._fromDate ; 
 }
  public setFromDate ( val : DateTime ) : void {
 let isValChanged :boolean=this._fromDate !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(SalesLeadCountRequest._FROMDATE,this._fromDate);

this._fromDate=val;

this.fire('fromDate',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case SalesLeadCountRequest._USER : {
 return this._user ; 
 }

case SalesLeadCountRequest._PAGESIZE : {
 return this._pageSize ; 
 }

case SalesLeadCountRequest._TODATE : {
 return this._toDate ; 
 }

case SalesLeadCountRequest._FROMDATE : {
 return this._fromDate ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : SalesLeadCountRequest {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :SalesLeadCountRequest=( dbObj as SalesLeadCountRequest );

obj.id=this.id;

obj.setUser(this._user);

obj.setPageSize(this._pageSize);

obj.setToDate(this._toDate);

obj.setFromDate(this._fromDate);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case SalesLeadCountRequest._USER : {
 this.setUser(( value as User ));
 break; }

case SalesLeadCountRequest._PAGESIZE : {
 this.setPageSize(( value as number ));
 break; }

case SalesLeadCountRequest._TODATE : {
 this.setToDate(( value as DateTime ));
 break; }

case SalesLeadCountRequest._FROMDATE : {
 this.setFromDate(( value as DateTime ));
 break; }
 }
 }
 }